import { useEffect, useState } from 'react'

/**
 * Immediately sets focus to the given element when it changes or is initially rendered
 * To use pass the returned value to the ref attribute of the element you want to have focus
 */
export const useFocusOnElement = () => {
  const [element, setElement] = useState<HTMLElement | null>(null)
  useEffect(() => {
    element?.focus()
  }, [element])

  return setElement
}
